export default __webpack_public_path__ + "static/christmas-banner-desktop-c4ac8fae5eea4d846d8d85f732ac743e.png";